import { render, staticRenderFns } from "./Installations.vue?vue&type=template&id=bda61696&scoped=true&"
import script from "./Installations.vue?vue&type=script&lang=js&"
export * from "./Installations.vue?vue&type=script&lang=js&"
import style0 from "./Installations.vue?vue&type=style&index=0&id=bda61696&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda61696",
  null
  
)

export default component.exports